import { Component, Vue, Prop } from 'vue-property-decorator';
import template from './oeic-person.vue';
import AccordionMixin from '../../../../shared/accordion/accordionMixin';
import * as mws from '../../../../shared/MwsViewModels';

@Component({
  mixins: [
    template,
    AccordionMixin,
  ],
})
export default class OeicPerson extends Vue {
  @Prop()
  person: mws.Person;

  getName(person: mws.Person): string {
    return person.title ? `${person.title} - ${person.name}` : person.name;
  }
}
